import React, { lazy } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-20 pb-8 px-4 bg-brand-light" data-id="element-292">
      <div className="max-w-5xl mx-auto text-center" data-id="element-293">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-294">
          <span data-id="element-295">🏆</span> El único sistema completo de carpintería en acero de
          Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-296">
          🔥 MANUAL DEL MAESTRO CARPINTERO DEL ACERO
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-amber mb-8" data-id="element-297">
          MEGA PACK COMPLETO
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12" data-id="element-298">
          5 Tomos Maestros con 390 páginas. Planos exactos, sistema de costos,
          guiones de venta y todo lo que necesitás para fabricar y vender desde
          el primer día.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-299">
          {['T1', 'T2', 'T3', 'T4', 'T5'].map(tomo => <div key={tomo} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-steel border-2 border-brand-steel/10" data-id="element-300">
              {tomo}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-301">
          <div className="text-left bg-white p-8 rounded-2xl shadow-xl" data-id="element-302">
            <h4 className="text-2xl font-black text-brand-dark mb-6 border-b pb-4" data-id="element-303">
              5 TOMOS MAESTROS
            </h4>
            <ul className="space-y-4" data-id="element-304">
              {['Sistema paso a paso desde cero', 'Planos y medidas exactas', 'Guiones de venta incluidos', '3 bonos de regalo', 'Acceso inmediato'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-305">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-306" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-307">
            <a href="#compra" className="block cursor-pointer md:transform md:hover:scale-[1.02] transition-transform duration-300" data-id="element-308">
              <img src="https://cdn.magicpatterns.com/uploads/2FfumGWEQBmcJHzgog7GL7/heylloyd-image-1773353141010.png" alt="Manual del Maestro Carpintero del Acero — Mega Pack Completo" className="w-full drop-shadow-2xl" width={768} height={432} loading="lazy" decoding="async" data-id="element-309" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}